import { IModifyRequestStatus } from "./file/types";

export const STATUSES: { [key in IModifyRequestStatus]: string } = {
    created: 'Үүссэн',
    resolved: 'Шийдсэн',
    manual: 'Данс',
    rejected: 'Татгалзсан'
}